
import CurrentUserService from '@/services/currentUserService';
import { ElMessageBox } from 'element-plus';
import { Vue } from 'vue-class-component';
import AccountType from '@/constants/AccountType';
import { Watch } from 'vue-property-decorator';

export default class Header extends Vue {
  private account = CurrentUserService.GetUserInfo().account;

  private readonly userInfo = CurrentUserService.GetUserInfo();

  private isAdmin = true;

  private menus = [
    { path: '/', text: '首页', name: 'All' },
    { path: '/resource', text: '资源管理', name: 'ServiceConfigLink' },
    { path: '/customer', text: '客户管理', name: 'CustomerLink' },
    { path: '/userinfo', text: '子账号管理', name: 'UserInfoLink' },
    { path: '/role', text: '角色管理', name: 'RoleLink' },
    { path: '/application', text: '应用管理', name: 'ApplicationLink' },
  ];

  private activeMenu = '/';

  mounted(): void {
    const currentPath = this.$route.path;
    this.setActiveMenu(currentPath);
    this.isAdmin = this.userInfo.accountType === AccountType.PlateAccount || this.userInfo.accountType === AccountType.PlateSubAccount;
    this.menus = this.menus.filter(
      // eslint-disable-next-line comma-dangle
      (it) => this.userInfo.role.includes(it.name) || it.name === 'All'
    );
    console.log(this.menus);
    
  }

  @Watch('$route')
  onRouteChange(to: any, from: any):void {
    const newPath = to.path;
    this.setActiveMenu(newPath);
  }

  setActiveMenu(newPath:string): void {
    if (newPath !== this.activeMenu) {
      const result = this.menus.filter((it:any) => newPath.startsWith(it.path) && it.path !== '/');
      if (result && result.length > 0) {
        this.activeMenu = result[0].path;
      } else {
        this.activeMenu = newPath;
      }
    }
  }

  logOut(): void {
    ElMessageBox.confirm(
      '是否确认退出当前账号?',
      '退出登录',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      },
    )
      .then(() => {
        sessionStorage.clear();
        this.$router.push('/login');
      });
  }

  modifyPassword(): void {
    this.$router.push('/modifyPassword');
  }

  personal(): void {
    this.$router.push('/personal');
  }
}
